function ingredientMap(ingredients) {
    return ingredients instanceof Map ? ingredients : new Map(Object.entries(ingredients));
}
/** Standard unit cost from a prep recipe BOM at full yield. */
export function computePrepStandardCost(prepYield, items, ingredients) {
    const ingMap = ingredientMap(ingredients);
    const hasSubRecipes = items.some((it) => it.sub_recipe_id);
    const missingCosts = [];
    let batchCost = 0;
    for (const it of items) {
        if (!it.ingredient_id || it.sub_recipe_id)
            continue;
        const ing = ingMap.get(it.ingredient_id);
        const cost = Number(ing?.cost_price ?? 0);
        if (!ing || cost <= 0) {
            missingCosts.push({
                id: it.ingredient_id,
                name: ing?.name ?? it.ingredient_id,
            });
        }
        batchCost += Number(it.quantity) * cost;
    }
    const unitCost = prepYield > 0 ? batchCost / prepYield : 0;
    return { batchCost, unitCost, missingCosts, hasSubRecipes };
}
/** Actual raw cost for a batch scaled to actual output qty. */
export function computeBatchRawCost(items, scale, ingredients) {
    const ingMap = ingredientMap(ingredients);
    const missingCosts = [];
    let rawCost = 0;
    for (const it of items) {
        if (!it.ingredient_id || it.sub_recipe_id)
            continue;
        const ing = ingMap.get(it.ingredient_id);
        const cost = Number(ing?.cost_price ?? 0);
        const qty = Number(it.quantity) * scale;
        if (!ing || cost <= 0) {
            missingCosts.push({
                id: it.ingredient_id,
                name: ing?.name ?? it.ingredient_id,
            });
        }
        rawCost += qty * cost;
    }
    return { rawCost, missingCosts };
}
export function computeBatchUnitCost(rawCost, actualQtyProduced) {
    return actualQtyProduced > 0 ? rawCost / actualQtyProduced : 0;
}
/**
 * Prep ingredient cost_price after crediting a batch.
 * Uses weighted average when prior stock has a known cost; otherwise adopts batch unit cost.
 */
export function nextPrepIngredientCost(oldStock, oldCost, batchQty, batchUnitCost) {
    if (batchQty <= 0)
        return oldCost;
    if (oldStock <= 0 || oldCost <= 0)
        return batchUnitCost;
    return (oldStock * oldCost + batchQty * batchUnitCost) / (oldStock + batchQty);
}
//# sourceMappingURL=prepCost.js.map